ux-iws-sf-page-content {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: stretch;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    margin: 0 auto;
    padding: 0;
    box-shadow: 0 0 25px rgba(0, 0, 0, 0.1);
    max-width: 1024px;

    ux-input-label .ux-label {
        display: inline-flex;
        flex-flow: row wrap;
        align-items: center;
        justify-content: flex-start;
        gap: 5px;
    }

    ux-select {
        --ux-button-border-color: var(--ux-input-border-color);
    }

    &[size="s"] {
        max-width: 500px;
    }

    &[size="m"] {
        max-width: 1024px;
    }

    &[size="l"] {
        max-width: 1440px;
    }
}
